import { render } from "./App.vue?vue&type=template&id=1293feaa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1293feaa&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__